// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("./Utils.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let AvatarDefaultSvg = require("../../assets/images/elements/avatar-default.svg");

let _placeholder = AvatarDefaultSvg;

function from_key(widthOpt, heightOpt, key) {
  let width = widthOpt !== undefined ? widthOpt : 60;
  let height = heightOpt !== undefined ? heightOpt : 60;
  return Stdlib_Option.getOr(Stdlib_Option.map(key, v => Utils.makeAttachmentUrl(width, height, true, undefined, undefined, undefined, v)), _placeholder);
}

let place_holder = from_key(undefined, undefined, undefined);

let placeholder = place_holder;

exports.from_key = from_key;
exports.place_holder = place_holder;
exports.placeholder = placeholder;
/* _placeholder Not a pure module */
